<div class="page-head">
  <div>
    <p class="eyebrow">การเงิน</p>
    <h1>รายการรายรับ</h1>
    <p>ติดตามยอดรับชำระจากลูกค้าที่ผ่านการตรวจสอบแล้ว</p>
  </div>
  <button
    type="button"
    class="tw-button inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] active:scale-[0.98]"
    (click)="exportExcel()"
  >
    <lucide-icon name="Download" [size]="17" />
    Export Excel
  </button>
</div>

<!-- <section class="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
  <article class="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
    <p class="m-0 text-xs font-medium text-slate-500">ยอดรับจากลูกค้า</p>
    <p class="mt-2 mb-0 text-2xl font-bold text-slate-800 tabular-nums">
      {{ incomeTotal() | number: '1.2-2' }}
    </p>
    <p class="mt-1 mb-0 text-xs text-slate-500">บาท · ตามตัวกรอง</p>
  </article>
  <article class="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
    <p class="m-0 text-xs font-medium text-slate-500">ค่าธรรมเนียมทั้งหมด</p>
    <p class="mt-2 mb-0 text-2xl font-bold text-slate-800 tabular-nums">
      {{ feeTotal() | number: '1.2-2' }}
    </p>
    <p class="mt-1 mb-0 text-xs text-slate-500">บาท · ลูกค้าและบริษัท</p>
  </article>
  <article class="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
    <p class="m-0 text-xs font-medium text-slate-500">ค่าธรรมเนียมที่บริษัทรับภาระ</p>
    <p class="mt-2 mb-0 text-2xl font-bold text-slate-800 tabular-nums">
      {{ companyFeeTotal() | number: '1.2-2' }}
    </p>
    <p class="mt-1 mb-0 text-xs text-slate-500">บาท · ต้นทุนของบริษัท</p>
  </article>
  <article class="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
    <p class="m-0 text-xs font-medium text-slate-500">จำนวนรายการ</p>
    <p class="mt-2 mb-0 text-2xl font-bold text-slate-800 tabular-nums">
      {{ filteredItems().length | number }}
    </p>
    <p class="mt-1 mb-0 text-xs text-slate-500">รายการที่ตรวจสอบแล้ว</p>
  </article>
</section> -->

<section class="mt-5 rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
  <div>
    <div class="mb-4">
      <h2 class="m-0 text-base font-bold text-slate-800">ตัวกรองรายการ</h2>
      <p class="mt-1 mb-0 text-xs text-slate-500">เลือกช่วงวันที่ งวด และช่องทางรับชำระ</p>
    </div>

    <div class="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
      <label class="block">
        <span class="mb-1.5 block text-xs font-semibold text-slate-600">วันที่เริ่มต้น</span>
        <p-datepicker
          class="w-full"
          [ngModel]="pendingDateFrom()"
          (ngModelChange)="pendingDateFrom.set($event)"
          dateFormat="dd/mm/yy"
          placeholder="เลือกวันที่เริ่มต้น"
          [showIcon]="true"
          [showClear]="true"
          [readonlyInput]="true"
          appendTo="body"
        />
      </label>
      <label class="block">
        <span class="mb-1.5 block text-xs font-semibold text-slate-600">วันที่สิ้นสุด</span>
        <p-datepicker
          class="w-full"
          [ngModel]="pendingDateTo()"
          (ngModelChange)="pendingDateTo.set($event)"
          dateFormat="dd/mm/yy"
          placeholder="เลือกวันที่สิ้นสุด"
          [showIcon]="true"
          [showClear]="true"
          [readonlyInput]="true"
          appendTo="body"
        />
      </label>
      <label class="block">
        <span class="mb-1.5 block text-xs font-semibold text-slate-600">งวดการชำระ</span>
        <p-select
          class="w-full"
          [options]="paymentStageOptions"
          [ngModel]="pendingPaymentStage()"
          (ngModelChange)="pendingPaymentStage.set($event)"
          optionLabel="label"
          optionValue="value"
          placeholder="เลือกงวดการชำระ"
        />
      </label>
      <label class="block">
        <span class="mb-1.5 block text-xs font-semibold text-slate-600">ช่องทางรับชำระ</span>
        <p-select
          class="w-full"
          [options]="paymentMethodOptions"
          [ngModel]="pendingPaymentMethod()"
          (ngModelChange)="pendingPaymentMethod.set($event)"
          optionLabel="label"
          optionValue="value"
          placeholder="เลือกช่องทางรับชำระ"
        />
      </label>
    </div>

    <div class="mt-4 flex flex-wrap justify-center gap-2">
      <button
        type="button"
        class="tw-button inline-flex items-center justify-center gap-1.5 rounded-lg bg-[var(--theme-color)] px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] active:scale-[0.98]"
        (click)="applyFilters()"
      >
        <lucide-icon name="Search" [size]="16" /> ค้นหา
      </button>
      <button
        type="button"
        class="tw-button inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-50"
        (click)="resetFilters()"
      >
        <lucide-icon name="RotateCcw" [size]="15" /> ล้างค่า
      </button>
    </div>
  </div>
</section>

<section class="mt-5 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
  <div
    class="flex flex-col gap-4 border-b border-slate-200 px-5 py-4 lg:flex-row lg:items-end lg:justify-between sm:px-6"
  >
    <div>
      <h2 class="m-0 text-base font-bold text-slate-800">รายรับที่ตรวจสอบแล้ว</h2>
      <p class="mt-1 mb-0 text-xs text-slate-500">
        แสดงยอดรับชำระ ค่าธรรมเนียม และยอดหัก ณ ที่จ่ายของแต่ละรายการ
      </p>
    </div>
    <div class="flex w-full flex-wrap items-center gap-2 lg:w-auto lg:justify-end">
      <span
        class="rounded-full bg-slate-100 px-2.5 py-1.5 text-[10px] font-semibold text-slate-600"
      >
        {{ filteredItems().length }} รายการ
      </span>
      <span
        class="rounded-full bg-emerald-50 px-2.5 py-1.5 text-[10px] font-semibold text-emerald-700 tabular-nums"
      >
        {{ incomeTotal() | number: '1.2-2' }}
      </span>
      <label class="relative block w-full sm:w-96">
        <lucide-icon
          name="Search"
          [size]="16"
          class="pointer-events-none absolute top-1/2 left-3 z-10 -translate-y-1/2 text-slate-400"
        />
        <input
          pInputText
          type="search"
          class="h-10 w-full pr-3 text-sm placeholder:text-slate-400"
          style="padding-left: 2.75rem; border-radius: 0.5rem"
          placeholder="ค้นหาเลขรับชำระ, Booking, รหัสทัวร์, ชื่อทัวร์, ลูกค้า หรือผู้ชำระ"
          [ngModel]="searchTerm()"
          (ngModelChange)="searchTerm.set($event)"
        />
      </label>
    </div>
  </div>

  <p-table
    [value]="filteredItems()"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="แสดง {first} ถึง {last} จาก {totalRecords} รายการ"
    [tableStyle]="{ 'min-width': '1700px' }"
  >
    <ng-template #header>
      <tr>
        <th class="w-14 px-5 py-3 text-center font-semibold whitespace-nowrap">ลำดับ</th>
        <th
          pSortableColumn="paymentDate"
          class="min-w-44 px-5 py-3 font-semibold whitespace-nowrap"
        >
          วันที่และเลขรับชำระ <p-sortIcon field="paymentDate" />
        </th>
        <th pSortableColumn="bookingNo" class="min-w-52 px-5 py-3 font-semibold whitespace-nowrap">
          Booking และลูกค้า <p-sortIcon field="bookingNo" />
        </th>
        <th pSortableColumn="tourCode" class="min-w-60 px-5 py-3 font-semibold whitespace-nowrap">
          รหัสและชื่อทัวร์ <p-sortIcon field="tourCode" />
        </th>
        <th
          pSortableColumn="paymentStage"
          class="min-w-44 px-5 py-3 font-semibold whitespace-nowrap"
        >
          งวดและช่องทาง <p-sortIcon field="paymentStage" />
        </th>
        <th class="min-w-44 px-5 py-3 font-semibold whitespace-nowrap">ผู้ชำระ / ผู้ตรวจสอบ</th>
        <th
          pSortableColumn="amount"
          class="min-w-40 px-5 py-3 text-right font-semibold whitespace-nowrap"
        >
          ยอดรายการ <p-sortIcon field="amount" />
        </th>
        <th class="min-w-40 px-5 py-3 text-right font-semibold whitespace-nowrap">ค่าธรรมเนียม</th>
        <th
          pSortableColumn="customerPaidAmount"
          class="min-w-40 px-5 py-3 text-right font-semibold whitespace-nowrap"
        >
          รับจากลูกค้า <p-sortIcon field="customerPaidAmount" />
        </th>
        <th
          pSortableColumn="withholdingTaxAmount"
          class="min-w-40 px-5 py-3 text-right font-semibold whitespace-nowrap"
        >
          หัก ณ ที่จ่าย <p-sortIcon field="withholdingTaxAmount" />
        </th>
        <th class="w-28 px-5 py-3 text-center font-semibold whitespace-nowrap">สลิปโอนเงิน</th>
        <th class="w-24 px-5 py-3 text-center font-semibold whitespace-nowrap">ดำเนินการ</th>
      </tr>
    </ng-template>

    <ng-template #body let-item let-rowIndex="rowIndex">
      <tr class="transition even:bg-slate-50/40 hover:bg-sky-50/50">
        <td
          class="px-5 py-3.5 text-[13px] text-slate-400 tabular-nums"
          style="vertical-align: middle"
        >
          <div class="flex w-full items-center justify-center">
            {{ rowIndex + 1 }}
          </div>
        </td>
        <td class="px-5 py-3.5 align-top">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-slate-800">
            {{ item.paymentDate | date: 'dd MMM yyyy' }}
          </p>
          <p class="mt-1 mb-0 text-xs font-medium whitespace-nowrap text-sky-700">
            {{ item.paymentNo }}
          </p>
        </td>
        <td class="px-5 py-3.5 align-top">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-sky-700">
            {{ item.bookingNo }}
          </p>
          <p class="mt-1 mb-0 text-xs text-slate-500">{{ item.customerName }}</p>
        </td>
        <td class="px-5 py-3.5 align-top">
          <p class="m-0 text-sm font-semibold text-slate-700">{{ item.tourCode || '—' }}</p>
          <p class="mt-1 mb-0 text-xs text-slate-500">{{ item.tourName }}</p>
        </td>
        <td class="px-5 py-3.5 align-top">
          <p class="m-0 text-sm font-medium text-slate-700">
            {{ paymentStageLabel(item.paymentStage) }}
          </p>
          <p class="mt-1 mb-0 text-xs text-slate-500">{{ paymentMethodLabel(item) }}</p>
        </td>
        <td class="px-5 py-3.5 align-top">
          <p class="m-0 text-sm text-slate-700">{{ item.payerName }}</p>
          <p class="mt-1 mb-0 text-xs text-slate-500">ตรวจโดย {{ item.verifiedByName }}</p>
          @if (item.verifiedAt) {
            <p class="mt-1 mb-0 text-[10px] text-slate-400">
              {{ item.verifiedAt | date: 'dd/MM/yyyy HH:mm' }} น.
            </p>
          }
        </td>
        <td
          class="px-5 py-3.5 text-right text-sm font-semibold whitespace-nowrap text-slate-700 tabular-nums align-top"
        >
          {{ item.amount | number: '1.2-2' }}
        </td>
        <td class="px-5 py-3.5 text-right align-top">
          @if (item.creditCardFeeAmount > 0) {
            <p class="m-0 text-sm font-semibold whitespace-nowrap text-slate-700 tabular-nums">
              {{ item.creditCardFeeAmount | number: '1.2-2' }}
            </p>
            <p class="mt-1 mb-0 text-[10px] whitespace-nowrap text-slate-500">
              {{ feeResponsibilityLabel(item.creditCardFeeResponsibility) }}
            </p>
          } @else {
            <span class="text-sm text-slate-400">—</span>
          }
        </td>
        <td
          class="px-5 py-3.5 text-right text-sm font-semibold whitespace-nowrap text-emerald-700 tabular-nums align-top"
        >
          {{ item.customerPaidAmount | number: '1.2-2' }}
        </td>
        <td class="px-5 py-3.5 text-right align-top">
          @if (item.withholdingTaxAmount > 0) {
            <p class="m-0 text-sm font-medium whitespace-nowrap text-slate-500 tabular-nums">
              {{ item.withholdingTaxAmount | number: '1.2-2' }}
            </p>
          } @else {
            <span class="text-sm text-slate-400">—</span>
          }
        </td>
        <td class="px-5 py-3.5 text-center align-middle">
          @if (item.slipUrl) {
            <button
              type="button"
              class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition hover:border-sky-200 hover:bg-sky-50 hover:text-sky-700"
              title="เปิดสลิปโอนเงิน"
              aria-label="เปิดสลิปโอนเงินในแท็บใหม่"
              (click)="openDocument(item.slipUrl)"
            >
              <lucide-icon name="ExternalLink" [size]="14" />
            </button>
          } @else {
            <span class="text-sm text-slate-400">—</span>
          }
        </td>
        <td class="px-5 py-3.5 text-center align-middle">
          <button
            type="button"
            class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition hover:border-sky-200 hover:bg-sky-50 hover:text-sky-700"
            title="แก้ไขลิงก์เอกสาร"
            aria-label="แก้ไขลิงก์ใบเสร็จและใบเสนอราคา"
            (click)="openEditLinks(item)"
          >
            <lucide-icon name="Pencil" [size]="14" />
          </button>
        </td>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td colspan="12" class="px-5 py-12 text-center">
          <div
            class="mx-auto grid size-12 place-items-center rounded-full bg-slate-100 text-slate-400"
          >
            <lucide-icon name="SearchX" [size]="21" />
          </div>
          <h3 class="mt-3 mb-0 text-sm font-semibold text-slate-700">ไม่พบรายการรายรับ</h3>
          <p class="mt-1 mb-0 text-xs text-slate-500">ลองเปลี่ยนคำค้นหา ช่วงวันที่ หรือตัวกรอง</p>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>

@if (selectedIncome(); as income) {
  <div
    class="fixed inset-0 z-[200] grid place-items-center overflow-y-auto bg-slate-950/45 p-4 backdrop-blur-[2px]"
    (click)="closeEditLinks()"
  >
    <section
      class="my-auto w-full max-w-2xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl"
      role="dialog"
      aria-modal="true"
      aria-labelledby="edit-income-links-title"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-start justify-between border-b border-slate-200 px-5 py-5 sm:px-6">
        <div>
          <p class="mb-1 text-xs font-semibold tracking-wider text-sky-600 uppercase">
            {{ income.paymentNo }}
          </p>
          <h2 id="edit-income-links-title" class="m-0 text-xl font-bold text-slate-800">
            แก้ไขลิงก์เอกสาร
          </h2>
          <p class="mt-1 mb-0 text-xs text-slate-500">
            {{ income.bookingNo }} · {{ income.customerName }}
          </p>
        </div>
        <button
          type="button"
          class="tw-button inline-flex size-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
          aria-label="ปิดหน้าต่าง"
          (click)="closeEditLinks()"
        >
          <lucide-icon name="X" [size]="19" />
        </button>
      </div>

      <div class="grid gap-4 p-5 sm:grid-cols-2 sm:p-6">
        <label class="grid content-start gap-1.5 text-sm font-semibold text-slate-700">
          <span>ลิงก์ใบเสร็จ</span>
          <input
            type="url"
            pInputText
            class="h-11 w-full font-normal"
            [class.p-invalid]="!!receiptUrlError()"
            [ngModel]="editReceiptUrl()"
            (ngModelChange)="editReceiptUrl.set($event); clearReceiptUrlError()"
            placeholder="https://example.com/receipt"
          />
          <span class="min-h-4">
            @if (receiptUrlError()) {
              <small class="font-normal text-red-600">{{ receiptUrlError() }}</small>
            }
          </span>
        </label>

        <label class="grid content-start gap-1.5 text-sm font-semibold text-slate-700">
          <span>ลิงก์ใบเสนอราคา</span>
          <input
            type="url"
            pInputText
            class="h-11 w-full font-normal"
            [class.p-invalid]="!!quotationUrlError()"
            [ngModel]="editQuotationUrl()"
            (ngModelChange)="editQuotationUrl.set($event); clearQuotationUrlError()"
            placeholder="https://example.com/quotation"
          />
          <span class="min-h-4">
            @if (quotationUrlError()) {
              <small class="font-normal text-red-600">{{ quotationUrlError() }}</small>
            }
          </span>
        </label>
      </div>

      <div
        class="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:flex-row sm:justify-end sm:px-6"
      >
        <button
          type="button"
          class="tw-button h-11 rounded-xl border border-slate-300 bg-white px-5 text-sm font-semibold text-slate-700 hover:bg-slate-100"
          (click)="closeEditLinks()"
        >
          ยกเลิก
        </button>
        <button
          type="button"
          class="tw-button inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-5 text-sm font-semibold text-white hover:bg-[var(--theme-hover)]"
          (click)="saveLinks()"
        >
          <lucide-icon name="Check" [size]="17" /> บันทึก
        </button>
      </div>
    </section>
  </div>
}
